import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LongCodeTypeValueRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';


@Component({
  selector: 'ngbeditcodedtype',
  templateUrl: './editcodedtype.modal.html',
  styleUrls: ['./editcodedtype.modal.scss']
})

export class NgbEditcodedtypeModal implements OnInit {

  @Input() CurrentEditLongCodeTypeValueRequest: LongCodeTypeValueRequest;
  //@Input() LongValue: string;
  //@Input() ShortValue: string;
  public isRequesting: boolean = false;
  public ApiResData: ApiResponseModel;
  public ShowService: boolean = true;
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService, private tosterservice: NGXToastrService,
    private actorservice: ActorService, private router: Router, private route: ActivatedRoute, private hcpservice: HCPService,) { }
  ngOnInit() {

    this.ShowService = false;    
    this.LoadRegistries();


  }
  LoadRegistries() {
    this.StartRefreshing();
         
  }

  onSubmit() {

    this.StartRefreshing();
    //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);
    this.CurrentEditLongCodeTypeValueRequest.ConditionalOperator = 2;
    //this.CurrentEditLongCodeTypeValueRequest.CodeTypeValueCode=
    this.actorservice.SaveCodeTypeValues(this.CurrentEditLongCodeTypeValueRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.ShowService = false;
            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );

  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  ModalClose() {
    this.activeModal.close();
  }





}
